import axios from 'axios';
import { IEmployeeBirthday } from "@/shared/model/hr/employee-birthday.model";


const apiUrl = 'api/employee-birthday';

export default class EmployeeBirthdayService {

  public getEmployeeBirthday(): Promise<IEmployeeBirthday> {
    return new Promise<IEmployeeBirthday>((resolve, reject) => {
      axios
        .get(apiUrl)
        .then(res => {
          resolve(res.data);
      }).catch(err => {
          reject(err);
      });
    });
  }

  public employeeBirthdayVisited(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(apiUrl + '/visited')
        .then(res => {
          resolve(res);
      }).catch(err => {
          reject(err);
      });
    });
  }

  public getEmployeeBirthdayPdf(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .get(`${apiUrl}/template-generate`)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
